import { render, staticRenderFns } from "./SolicitacaoToken.vue?vue&type=template&id=7e0fcef8&lang=pug"
import script from "./SolicitacaoToken.vue?vue&type=script&lang=js"
export * from "./SolicitacaoToken.vue?vue&type=script&lang=js"
import style0 from "./SolicitacaoToken.vue?vue&type=style&index=0&id=7e0fcef8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports